export const VERTICAL_OFFSET_TOPOLOGY_VIEW = 20;

// WHEN: opening to the right (i.e. when the gear icon is on the left side of the arrow head)
export const HORIZONTAL_OFFSET_TOPOLOGY_VIEW_OPEN_TO_RIGHT = 20;
